import React from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { ManageTypeFilter } from '../ManageTypeFilter';
import { translate } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import {
  isProductMasterDataManageType,
  ProductMasterDataManageType,
} from '../../../../../types/product_master_data/productMasterData';

export default function ManageTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<ProductMasterDataManageType>) {
  return (
    <InnerFilterContent<ProductMasterDataManageType>
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={Array.from(filterProps.manageType || [])}
      text={item =>
        isProductMasterDataManageType(item) ? ManageTypeFilter.toText(item) : translate({ key: TranslationKey.unknown })
      }
      onRemove={item => {
        if (!isProductMasterDataManageType(item)) return;
        filterProps.manageType?.delete(item);
        if (!filterProps.manageType?.size) filterProps.manageType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
